<template>

<div class='vue-form'>
  <div id='intro_page' v-show='intro_page'>
    <b-jumbotron header='Summer Financial Aid' lead='General Information' header-level='5'>
    </b-jumbotron>
    <ul class="info">
      <li>Summer is referred to as a leading semester for the coming fall and spring semesters. Therefore, you must file a Free Application for Federal Student Aid (FAFSA) for the upcoming academic year in order to apply for financial aid for summer. If you did not file a FAFSA for the preceding academic year, you should complete this also so we may determine if you have potential Pell Grant eligibility that could apply to summer. If you have not already done so, complete the FAFSA(s) at <a href="https://studentaid.gov/h/apply-for-aid/fafsa" target="_blank">https://studentaid.gov/h/apply-for-aid/fafsa</a> as soon as possible.</li>
      <li>Federal aid is available only to admitted, degree-seeking students at SD Mines. Non-degree students are not eligible for federal aid. Students must also be meeting satisfactory academic progress guidelines for federal student aid.</li>
      <li>For financial aid purposes, enrollment status for summer is the same as it is for the regular fall and spring semesters. Therefore, 12 or more credits are considered full time for undergraduate students and 9 or more credits are considered full time for graduate students (exception for thesis/dissertation credits). For student loans, you must be enrolled at least half-time (which is 6 credits for undergraduates and 5 credits for graduates (exception for thesis/dissertation credits)). You are required to inform our office immediately if you reduce the number of credits from what you list on this application, regardless if the change is initiated by you or the class is canceled. Depending on the type of aid you are receiving, your aid may be reduced or canceled.</li>
      <li>No aid is disbursed prior to the first day of your first summer class. Tuition and fees must be paid in full by the June 10, whether by financial aid, a 3rd party or personal resources.</li>
      <li>You will receive a financial aid offer notification that must be accepted before aid will be disbursed to you.</li>
    </ul>
    <p>The types of aid potentially available for summer are:</p>
    <ul class="info">
      <li><strong>Federal Grants: </strong> Pell Grant eligibility for summer will be determined on an individual basis. Any Pell Grant received for summer is included in your lifetime eligibility limit. If you wish to discuss this further, please speak with a Financial Aid Office staff member.</li>
      <li>
        <strong>Federal Student Loans: </strong> If you would like to borrow a Federal Student Loan, our office will determine your eligibility for Federal Subsidized and/or Unsubsidized Loan(s) for summer.
        <ul class="info">
          <li>For Federal subsidized/unsubsidized loans, you may be awarded up to 1/3 of your grade level maximum for the upcoming academic year. Unused loan funds originally awarded for the preceding academic year are not available for summer. As a result, borrowing in the summer will directly reduce the amount of loan funds you will have available for the following fall and spring semesters. Loan funds will be disbursed at the beginning of your first session of attendance.</li>
          <li>For loans, request only the amount you will need to borrow for summer. Keep in mind that your annual subsidized/unsubsidized limit remains the same, so the amount that you borrow during summer will reduce your fall/spring eligibility.</li>
        </ul>
      </li>
      <li><strong>Private Student Loans </strong> You may apply for a private student loan if you do not want or are ineligible to borrow federal student loans during summer. See <a href="https://sdsmt.edu/FinAid/PrivateAlternativeLoans">https://sdsmt.edu/FinAid/PrivateAlternativeLoans for more details.</a></li>
      
    </ul>
    <b-alert show variant="warning" id="terms-gp" name="terms-gp" v-if='terms.show'>
        <h6 v-if="terms.title">{{terms.title}}</h6>
        <p class="help-text" v-if="terms.text">{{terms.text}}</p>
        <hr v-if="terms.text">
        <b-form-checkbox id="terms-cb" name="terms-cb" v-model="terms.data" value="true" unchecked-value="false" v-validate.initial="'required'">{{terms.label}}</b-form-checkbox>
    </b-alert>
    <b-button v-show='terms.data === "true"' size='md' type='button' variant='dark' @click='applypage'>Continue to application ></b-button>
  </div>
   
  
  <b-jumbotron :header='intro.title' :lead='intro.subtitle' header-level='5' v-show='!intro_page'>
    <hr />
    <p v-html="intro.desc">
    </p>
    <a href="#" @click="applypage">Return to information page</a>
  </b-jumbotron>
  
  <form ref='form' :action='results.action' method='post' @submit='onSubmit' name="vfm" v-show='!intro_page'>
    <input type='hidden' name='post' :value='results.post' />
    <!-- <div class='email_field_group' v-for='email, index in results.emails'>
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_from_name"' :value='email.from_name' />
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_from"' :value='email.from' />
      <input v-if='(email.to === "self")' type='hidden' :name='"email_" + (index+1).toString()+ "_to"' :value='items.vfm_email.data'  />
      <input v-else type='hidden' :name='"email_" + (index+1).toString()+ "_to"' :value='email.to' />
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_subject"' :value='email.subject' />
      <input type='hidden' :name='"email_" + (index+1).toString()+ "_body"' :value='email.body' />
    </div> -->

    <div class='email_field_group'>
      <input type='hidden' :name='"email_1_from_name"' :value='results.emails[0].from_name' />
      <input type='hidden' :name='"email_1_from"' :value='results.emails[0].from' />
      <input type='hidden' :name='"email_1_to"' :value='results.emails[0].to' />
      <input type='hidden' :name='"email_1_subject"' :value='results.emails[0].subject' />
      <input type='hidden' :name='"email_1_body"' :value='email_1_body' />
    </div>

    <div class='email_field_group'>
      <input type='hidden' :name='"email_2_from_name"' :value='results.emails[1].from_name' />
      <input type='hidden' :name='"email_2_from"' :value='results.emails[1].from' />
      <input type='hidden' :name='"email_2_to"' :value='items.vfm_email.data' />
      <input type='hidden' :name='"email_2_subject"' :value='results.emails[1].subject' />
      <input type='hidden' :name='"email_2_body"' :value='email_2_body' />
    </div>

    <div class='csv_field_group' v-for='csv, f_index in csvPath_a'>
      <input type='hidden' :name='"csv_"+(f_index+1).toString()+"_file"' :value='csv.path' />
      <!-- <input v-for='item, key, i_index in items' v-if='csv.omit.indexOf(key) === -1' :key='key' :name='csvEnum(item.name, f_index, i_index)' type='hidden' :value='item.name' /> -->
      <input v-for='item, key, i_index in items' :key='key' :name='csvEnum(item.name, f_index, i_index)' type='hidden' :value='getCSVValue(csv.omit, key)' />
      <input :name='stampEnum(f_index)' type='hidden' value='Stamp' />
    </div>

    <input type='hidden' name='Enroll' :value='results.enroll' />
    <input type='hidden' name='Stamp' :value='results.stamp' />
    <input type='hidden' name='confirm' :value='results.confirm' />
    <input type='hidden' name='confirm_template' :value='confirm_template'  />
    <!-- <div class='miners'>
      <label>hidden label
      <input class='miners' name='miners' value='' />
      </label>
    </div> -->

    <div class='vfm_item' v-for='item, key in items'>
      <div v-if="item.section_header && item.show">
        <hr  class="sect"/>
        <h3>{{ item.section_header }}</h3>
      </div>
      
      <span v-if="item.group"><span v-if="item.group === 'start' && item.show">
          <h4 v-if="item.group_label">{{ item.group_label }}</h4>
          <hr v-else />
        </span>
      </span>
            
      <b-form-group v-if='((item.type === "radio"))' v-show='item.show' :label-for='item.name' :description='item.help'>
        
        <label>{{ item.label }}
        <b-form-radio-group stacked v-model='item.data' v-on:input='radioTrig(key, item.ctrl, item.data)' :name='item.name' :options='item.init.options'></b-form-radio-group>
        <input hidden type='radio' :name='item.name' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}' />
        </label>

        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>
      
      <b-form-group
					v-else-if="item.type === 'currency'"
					v-show="item.show"
					:label="item.label"
					:label-for="item.name"
					:description="item.help"
				>
					<b-input-group prepend="$" append=".00">
						<b-form-input
              onkeypress="return event.charCode >=48 && event.charCode <= 57"
							type="number"
							step="1"
							min="1"
							:name="item.name"
							:id="item.name"
							v-model="item.data"
							:placeholder="vfm_init(key)"
							v-validate="item.reqs"
							:class="{ 'is-danger': errors.has(item.name) }"
						></b-form-input>
					</b-input-group>
					<div v-show="errors.has(item.name)" class="danger is-danger">
						{{ errors.first(item.name) }}
					</div>
				</b-form-group>

      <b-form-group v-else-if='((item.type === "select"))' v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help'>
        <b-form-select v-model='item.data' :name='item.name' :options='vfm_init(key)' v-validate='item.reqs' data-vv-validate-on='blur' :class='{"is-danger":errors.has(item.name)}'>
        </b-form-select>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='((item.type === "checkbox"))' v-show='item.show' :label-for='item.name'>
        <b-form-checkbox v-model='item.data' :name='item.name' unchecked-value='no' value='yes' v-validate='item.reqs'> {{ item.label }}
        </b-form-checkbox>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='(item.type === "textarea")' v-show='item.show' :label-for='item.name' :description='item.help'>
        
        <label style="width: 100%">{{ item.label }}
        <b-form-textarea v-model='item.data' :name='item.name' :placeholder='item.init.placeholder' :rows='5' :max-rows='10' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}'></b-form-textarea>
        </label>
        
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>

      <b-form-group v-else-if='(item.type === "link")' v-show='item.show' :description='item.help'>
        <span v-html='item.label'></span>
      </b-form-group>
      
      <div class='auto' v-else-if='(item.type === "auto")' v-show='item.show'>
        <input type="hidden" :name="item.name" id="item.name" v-model="total_credits" />
        <span class='label'>{{ item.label}}:</span> {{ total_credits }}
      </div>

      <b-form-group v-else v-show='item.show' :label='item.label' :label-for='item.name' :description='item.help'>
        <b-form-input :type='item.type' :name='item.name' :id='item.name' v-model='item.data' :placeholder='vfm_init(key)' v-validate='item.reqs' :class='{"is-danger":errors.has(item.name)}'></b-form-input>
        <div v-show="errors.has(item.name)" class='danger is-danger'>{{errors.first(item.name)}}</div>
      </b-form-group>
      
      
      <span v-show="item.show">
        <span v-if='item.reveal'>
          <span v-show='(item.reveal && !items[item.reveal.target[0]].show)'>
            <b-btn variant='link' size='sm'  v-on:click='clickReveal(item)'>{{item.reveal.text}}</b-btn>
            <hr v-show='!(item.hide)' />
          </span>
        </span>
        <span v-if='(item.hide && item.reveal)'>
          <span  v-show='(item.hide && !items[item.reveal.target[0]].show)' >
            <b-btn variant='link' size='sm' v-on:click='clickHide(item)'>
              {{item.hide.text}}
            </b-btn>
            <hr />
          </span>
        </span>
        <span v-if='(item.hide && typeof(item.reveal) === "undefined")'>
          <span v-show='item.hide'>
            <b-btn variant='link' size='sm'  v-on:click='clickHide(item)'>
                {{item.hide.text}}
              </b-btn>
              <hr />
          </span>
        </span>
        <span v-if="item.group">
          <hr v-if="item.group === 'end' && item.show" />
        </span>
      </span>
  
    </div>

    <hr />
    <b-button :disabled='errors.any()' size='lg' type='submit' variant='dark'>Submit</b-button>
  </form>

  <div id="debug" class="debug" v-show="meta.debugdata">
    <h2>Debug</h2>
    <div>
      Errors = {{errors.any()}}<br /> {{errors.all()}}
    </div>
    <ul v-for='item in items'>
      <li>
        <div>{{item.name}}: <span class="data-debug">{{item.data}}</span></div>
        <div v-if='item.ctrl'>{{item.ctrl}}</div>
      </li>
    </ul>
    <div v-for='csv in csvPath_a'>
      {{csv.path}}
    </div>
    <div>
      {{ results.confirm }}
    </div>
  </div>

  <span id='templates' v-show="meta.debugtemplate">
    <hr />
      <h5>Confirmation Template</h5>
    <hr />
  
    <div id='confirm_template'>
      <b-row>
        <b-col><p>Thank you for submitting the <em>{{ meta.form_name }}</em> form.  The Financial Aid Office will contact you regarding your eligibility. If you have any questions in the meantime, please contact <a :href="'mailto:' + meta.poc_email_dept">{{ meta.poc_name1}}</a>.</p></b-col>
      </b-row>
      <hr />
      <b-row><strong>Submission Details:</strong></b-row>
      <span v-for="item in items" :key="item.name">
        <b-row v-if="item.data !== 0 && item.data !== ''">
          <b-col cols="6"><strong>{{ item.label }}</strong></b-col>
          <b-col cols="6">{{ item.data }}</b-col>
        </b-row>
      </span>
      <hr />
      <p><a href="https://www.sdsmt.edu/finaid/"> Return to Financial Aid</a></p>
    </div>
  
    <hr />
      <h5>Email 1</h5>
    <hr />

    <div id='email_template_1'>
      <div style=''>
        <table border="0" style="border-collapse: collapse; font: Arial normal 10pt ;" cellpadding="3">
          <tr>
              <td colspan="4">
                <p>This is an automated message to let you know that you have a new submission of the <em>{{ meta.form_name }}</em> form located at <a :href="'https://interact.sdsmt.edu/' + meta.root + '/' + meta.sub + '/'">https://interact.sdsmt.edu/{{meta.root}}/{{ meta.sub }}/</a>.</p>

                  <!-- <p>The link to the submission results file for this form is <a :href="'https://sdmines.sdsmt.edu/upload/results/' +results.csv_files[0].path + results.csv_files[0].file">https://sdmines.sdsmt.edu/upload/results/{{ results.csv_files[0].path }}{{ results.csv_files[0].file }}</a>. Remember, this file may contain personally identifiable information from previous submissions, so please do not share this link.</p> -->

                <p>If you have any trouble accessing the data you've received from this submission, please contact <a href="mailto:jason.ward@sdsmt.edu">ITS</a>.</p>
              </td>
          </tr>
        </table>
        <hr />
        <h4>Submission Information</h4>
        <hr />
        <table>
          <tr><td></td></tr>
            <tr v-for="item in items" :key="item.name">
              <td v-if="item.data !== 0 && item.data !== ''" style="vertical-align:top"><b>{{ item.label }}</b></td>
              <td v-if="item.data !== 0 && item.data !== ''" style="vertical-align:top">{{item.data}}</td>
            </tr>
          <tr><td></td></tr>
        </table>
      </div>
    </div>
  
    <hr />
      <h5>Email 2</h5>
    <hr />

    <div id='email_template_2'>
      <div style=''>
        <table border="0" style= "font: Arial normal 10pt ; table-layout: fixed; width: 100%;">
          <tr>
              <td colspan="4">
                <p>Thank you for submitting the <em>{{ meta.form_name }}</em> form.  The Financial Aid Office will contact you regarding your eligibility. If you have any questions in the meantime, please contact <a :href="'mailto:' + results.emails[0].to">{{ results.emails[0].from_name }}</a>.</p>
              </td>
          </tr>
        </table>
        <hr />
        <h4>Submission Information</h4>
        <hr  />
        <table>
          <tr><td></td></tr>
            <tr v-for="item in items" :key="item.name">
              <td v-if="item.data !== 0 && item.data !== ''" style="vertical-align:top"><b>{{ item.label }}: </b></td>
              <td v-if="item.data !== 0 && item.data !== ''" style="vertical-align:top">{{item.data}}</td>
            </tr>
          <tr><td></td></tr>
          <tr>
            <td colspan="4">
              <p>This is an automated response.</p>
            </td>
          </tr>
        </table>
      </div>
    </div>
  
  </span>
</div>
</template>

<script>
import {
  meta,
  intro,
  results,
  path_hash,
  terms,
  items
} from 'vfm/form-specs'

var timestamp = require('time-stamp');

export default {
  name: 'VueForm',
  computed: {
    
    total_credits: function(){
      let t = 0;
      t = parseInt(items.vfm_class_1_credits.data,10) + parseInt(items.vfm_class_2_credits.data,10)  + parseInt(items.vfm_class_3_credits.data,10) + parseInt(items.vfm_class_4_credits.data,10) + parseInt(items.vfm_class_5_credits.data,10) + parseInt(items.vfm_class_6_credits.data,10) + parseInt(items.vfm_class_7_credits.data,10) + parseInt(items.vfm_class_8_credits.data,10)
      if (!t) t=0
      items.vfm_total_credits.data = t
      return t
    },

    csvPath_a: function() {
      var a = [];
      for (var i = 0; i < this.results.csv_files.length; i++) {
        a[i] = {
          path: this.csvPath(i),
          omit: this.results.csv_files[i].omit
        };
      }
      return a;
    },

    vfm_combined_name: function() {
      var s = '';
      for (var i = 0; i < this.hiddens.email_from_name.length; i++) {
        if (i !== 0) {
          s += ' '
        }
        if (typeof this.items[this.hiddens.email_from_name[i]] !== 'undefined') {
          s += this.items[this.hiddens.email_from_name[i]];
        } else s += this.hiddens.email_from_name[i];
      }
      return s;
    },
  },

  data() {
    return {
      meta: meta,
      results: results,
      items: items,
      intro: intro,
      path_hash: path_hash,
      terms: terms,
      email_1_body: '',
      email_2_body: '',
      confirm_template: '',
      intro_page: true
    }
  },

  methods: {
    stampNow() {
      return timestamp('YYYY/MM/DD-HH:mm:ss')
    },
    
    applypage(){
      this.intro_page = !this.intro_page
      window.scrollTo(0,0) 
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.email_1_body = document.getElementById('email_template_1').innerHTML;
      this.email_2_body = document.getElementById('email_template_2').innerHTML;
      this.confirm_template = document.getElementById('confirm_template').innerHTML;
      results.stamp = this.stampNow();
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.results.miners !== '') {
            results.action = 'https://interact.sdsmt.edu/not-authorized.asp';
          } else {
            // update
            results.action = 'https://sdmines.sdsmt.edu/cgi-bin/global/send_message_2.cgi';

          }
          this.$nextTick(() => {
            this.$refs.form.submit();
          });

        } else {
          alert('Oops. Please fill in the required fields.');
        }
      });
    },
    
    clickReveal(item){
      item.reveal.target.forEach(function(t){
        items[t].show = true;
      })
    },

    clickHide(item){
      item.show = false;
      item.hide.target.forEach(function(t){
        items[t].show = false;
      })
    },

    getCSVValue(omit, key) {
      if (omit.indexOf(key) === -1) {
        return items[key].name;
      } else return ' - ';
    },

    vfm_init(key) {
      var item = items[key];
      switch (item.type) {
        case 'select':
          if (item.data === '') {
            item.data = null;
          }
          var ph = (item.init.placeholder ? item.init.placeholder : 'Choose an option');
          var top = [{
            text: ph,
            value: null
          }];

          if (typeof item.ctrl !== 'undefined') {
            if (typeof item.ctrl.from !== 'undefined') {
              var key = items[item.ctrl.from];
              var opts = item.init.options[key.data];
              if (typeof opts !== 'undefined') {
                if (opts.indexOf(item.data) === -1) {
                  item.data = null;
                }
                var opts_oa = [];
                for (var i = 0; i < opts.length; i++) {
                  opts_oa[i] = {
                    text: opts[i],
                    value: opts[i]
                  }
                }
                return (top.concat(opts_oa));
              }

              top[0].text = item.ctrl.msg ? item.ctrl.msg : 'Options depend on another field...';
              return (top);
            }
          }
          return (top.concat(item.init.options));
        default:
          return (item.init.placeholder ? item.init.placeholder : ['Enter response here.']);
      }
    },

    csvEnum(name, f_index, i_index) {
      return 'csv_' + (f_index + 1).toString() + '_field_' + (i_index + 1).toString();
    },

    stampEnum(f_index) {
      var max = Object.keys(items).length;
      return 'csv_' + (f_index + 1).toString() + '_field_' + (max + 1).toString();
    },

    csvPath(f_index) {
      var s = '/upload/results/';
      var ref = this.results.csv_files[f_index].file;
      var path = s + this.results.csv_files[f_index].path;
      // if there's a field with the same name as ref, use its data to build the filename
      if (typeof this.items[ref] !== 'undefined') {
        var key = this.items[ref].data;
        if (key !== null && key !== '') {
          var code = this.path_hash[key];
          if (typeof code !== 'undefined') {
            return path + key + '-' + code + '.csv';
          } else console.log('Code not found for hashed value.');
        }
        return path + key + '.csv';
      }
      //else csv_filed[i].file is just a filename string
      return path + ref;
    },

    radioTrig(key, ctrl, data) {
      var r = '';
      if (typeof ctrl !== 'undefined') {
        for (var j = 0; j < ctrl.length; j++) {
          if (ctrl[j].opener.value === data) {
            for (var i = 0; i < ctrl[j].targets.length; i++) {
              this.items[ctrl[j].targets[i]].show = true;
              r = this.items[ctrl[j].targets[i]].reqs;
              // r += '|required';
              r = ''.concat('required|', r);
              this.items[ctrl[j].targets[i]].reqs = r;
            }
          } else {
            for (var i = 0; i < ctrl[j].targets.length; i++) {
              this.items[ctrl[j].targets[i]].show = false;
              this.items[ctrl[j].targets[i]].data = '';
              r = this.items[ctrl[j].targets[i]].reqs;
              if (r.slice(0, 9) === 'required|') {
                r = r.slice(9);
              }
              // if (r.slice(-9) === '|required') {
              //   r = r.slice(0, (r.length - 9));
              // }
              this.items[ctrl[j].targets[i]].reqs = r;
            }
          }
        }
      }
    } // end radioTrig
  } // end methods
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h3{
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 1.6em;
}

h4{
  font-size: .8rem;
  font-weight: light;
  color: #071d49;
  background-color: #E9ECEF;
  padding: .6em;
  margin: 1em 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

ul.info, ul.info > li{
  list-style: disc;
  padding: 1rem;
  font-size: .9rem;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #385E9D;
}

div.is-danger {
  margin-top: .2rem;
  color: #B3A369;
  font-size: .8rem;
}

hr.sect {
  margin-top: 3em;
}

input.is-danger,
select.is-danger {
  border: solid #B3A369 1px;
}
.auto{
  margin-bottom: 1em;
}

.label{
  font-weight: bold;
}

.card-body p {
  font-size: .8rem;
  margin-bottom: 0;
}

.debug {
  font-size: .7em;
  max-width: 30%;
  height: 100%;
  overflow-y: scroll;
  position: fixed;
  border-right: solid 8px #B3A369;
  padding: 1em;
  right: 0;
  top: 0;
  background: rgba(7, 29, 73, 0.6);
  color: white;
  text-align: left;
}

.help-text {
  font-size: .8em;
  font-style: oblique;
  color: #666;
}

.data-debug {
  color: #999;
  font-style: oblique;
}

.jumbotron{
  /* background-color: #071d49;
  color: #fff;  */
  margin-bottom: 30px;
  font-size: .9rem;
  color: #071d49;
}

.miners {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/components/VueForm.vue